
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busbookingforweddindtripinpune() {



    const cardData =
    {
        keyword: 'Bus booking for wedding in Pune',
        heading: 'Amruta Travels: Bus booking for wedding in Pune',
        headingDescription: 'Book your wedding bus in Pune with Amruta Travels through our simple and hassle-free booking process. Whether you need a bus for a wedding ceremony, reception, guest pickup, or destination wedding, we offer instant booking assistance, transparent pricing, flexible schedules, and multiple seating options. Reserve your preferred bus in advance and enjoy professional support from booking confirmation until the completion of your event. Our easy booking system ensures your wedding transportation is planned without last-minute stress.',


        top: 'How to Book Your Wedding Bus with Amruta Travels',

    "topPlaces":[
{
"title":"Share Your Wedding Requirements",
"description":"Tell us your wedding date, venue, guest count, travel schedule, pickup locations, and preferred seating capacity."
},
{
"title":"Receive a Customized Quotation",
"description":"Based on your requirements, our team provides a transparent quotation with suitable bus options and pricing."
},
{
"title":"Select Your Preferred Bus",
"description":"Choose from 25, 32, 35, 45, and 50-seater AC or Non-AC buses according to your guest count and budget."
},
{
"title":"Confirm Your Booking",
"description":"Secure your wedding transportation by confirming your booking with our team. We reserve the selected buses for your event."
},
{
"title":"Flexible Payment Options",
"description":"Pay through convenient online or offline payment methods with transparent billing and no hidden charges."
},
{
"title":"Receive Booking Confirmation",
"description":"Get your booking confirmation along with driver details, reporting time, pickup schedule, and travel plan."
},
{
"title":"Pre-Wedding Coordination",
"description":"Our booking team coordinates with you before the wedding to confirm routes, timings, guest pickups, and any last-minute changes."
},
{
"title":"Wedding Day Transportation",
"description":"Our buses arrive on schedule to transport your guests safely and comfortably according to the finalized itinerary."
},
{
"title":"Support Throughout the Event",
"description":"Our support team remains available during your wedding to handle any transportation adjustments if required."
},
{
"title":"Easy Rescheduling Assistance",
"description":"If your wedding schedule changes, we assist with rescheduling subject to vehicle availability."
}

],

"services":[
{
"name":"Wedding Bus Booking Assistance",
"description":"Our booking specialists help you reserve the right bus for your wedding based on guest count, venue, travel schedule, and budget. Get expert guidance from enquiry to final confirmation."
},
{
"name":"Advance Wedding Bus Booking",
"description":"Reserve your wedding bus well in advance to ensure vehicle availability during peak wedding seasons. Early booking gives you more seating options and flexible scheduling."
},
{
"name":"Instant Wedding Bus Booking Confirmation",
"description":"Receive quick booking confirmation after your reservation is completed. We provide confirmation details, travel schedule, pickup timing, and driver information."
},
{
"name":"Online Wedding Bus Booking",
"description":"Book your wedding bus online with Amruta Travels through a simple and hassle-free booking process. Our team assists you throughout the reservation."
},
{
"name":"Wedding Guest Transportation Booking",
"description":"Reserve buses for wedding guests travelling from hotels, homes, airports, railway stations, and wedding venues with customized pickup planning."
},
{
"name":"Wedding Shuttle Booking",
"description":"Book shuttle buses for continuous guest transportation between hotels, marriage halls, reception venues, and parking areas."
},
{
"name":"Destination Wedding Bus Booking",
"description":"Planning a destination wedding in Lonavala, Mahabaleshwar, Alibaug, Nashik, Goa, or nearby cities? Book comfortable buses with advance scheduling."
},
{
"name":"Group Wedding Bus Reservation",
"description":"Reserve multiple buses for large wedding functions with coordinated booking, vehicle allocation, and travel management."
},
{
"name":"Last Minute Wedding Bus Booking",
"description":"Need urgent transportation? Subject to availability, we provide last-minute wedding bus booking assistance with quick confirmation."
},
{
"name":"Wedding Bus Booking Modification",
"description":"Need to change pickup timing, guest count, or travel schedule? Our booking team assists with modifications whenever possible."
},
{
"name":"Wedding Booking Support Team",
"description":"Our dedicated booking executives remain available before your wedding to coordinate routes, schedules, guest pickups, and travel updates."
},
{
"name":"Transparent Booking & Payment Process",
"description":"Enjoy clear quotations, transparent pricing, convenient payment options, and complete booking support without hidden charges."
}
],

tableData:[
["Wedding Bus Booking Assistance","Advance Wedding Bus Booking"],
["Online Wedding Bus Booking","Instant Booking Confirmation"],
["Wedding Bus Reservation","Wedding Guest Transportation Booking"],
["Wedding Shuttle Booking","Group Wedding Bus Reservation"],
["Destination Wedding Bus Booking","Corporate Wedding Bus Booking"],
["Last Minute Wedding Bus Booking","Wedding Booking Modification"],
["Transparent Booking Process","Easy Online Payment"]
],




"whychoose":[
{
"WhyChooseheading":"Simple Wedding Bus Booking Process",
"WhyChoosedescription":"Booking your wedding bus with Amruta Travels is quick and hassle-free. Our team guides you from your first enquiry until your booking is successfully confirmed."
},
{
"WhyChooseheading":"Instant Booking Confirmation",
"WhyChoosedescription":"Receive prompt booking confirmation with complete travel details, pickup schedule, reporting time, and vehicle information for complete peace of mind."
},
{
"WhyChooseheading":"Advance Reservation Facility",
"WhyChoosedescription":"Reserve your preferred wedding bus well in advance to ensure availability during busy wedding seasons and avoid last-minute transportation issues."
},
{
"WhyChooseheading":"Dedicated Booking Support",
"WhyChoosedescription":"Our booking executives help you select the right vehicle, coordinate guest transportation, answer your questions, and assist throughout the booking process."
},
{
"WhyChooseheading":"Flexible Booking Options",
"WhyChoosedescription":"Need multiple pickup points, destination wedding travel, or itinerary changes? We provide flexible booking solutions based on your wedding schedule."
},
{
"WhyChooseheading":"Transparent Booking & Pricing",
"WhyChoosedescription":"Every booking includes a clear quotation with transparent pricing, convenient payment options, and no hidden charges."
},
{
"WhyChooseheading":"Reliable Wedding Transportation Planning",
"WhyChoosedescription":"From booking confirmation to wedding day coordination, we carefully plan guest transportation so your event runs smoothly."
},
{
"WhyChooseheading":"Trusted Wedding Bus Booking in Pune",
"WhyChoosedescription":"Hundreds of families trust Amruta Travels for professional wedding bus booking services in Pune because of our reliable support, timely coordination, and customer-focused approach."
}
]


























    }

const faqData = [
  {
    question: 'How can I book a bus for a wedding in Pune with Amruta Travels?',
    answer: 'Booking a bus for your wedding in Pune with Amruta Travels is easy. You can book online, call our support team, or visit our office. We will guide you through the booking process and help select the right bus for your needs.',
  },
  {
    question: 'What types of buses are available for wedding transportation in Pune?',
    answer: 'We offer a range of buses for weddings, including 32, 35, 45, and 50 seater options. All our buses are spacious, comfortable, and equipped with air conditioning, ensuring a pleasant journey for your guests.',
  },
  {
    question: 'Are the buses suitable for transporting wedding guests?',
    answer: 'Yes, our buses are perfect for transporting wedding guests. They provide ample space for everyone, ensuring that your guests travel comfortably to and from the wedding venue.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations for the wedding?',
    answer: 'Yes, we offer flexible options for multiple pickup and drop-off locations for your wedding. Whether it’s from hotels, homes, or different venues, we’ll accommodate your needs and plan the route accordingly.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for wedding events?',
    answer: 'Yes, all our buses are regularly maintained and thoroughly sanitized before each trip, ensuring cleanliness, safety, and comfort for all passengers.',
  },
  {
    question: 'How much does it cost to book a bus for a wedding in Pune?',
    answer: 'The cost depends on the bus type, duration, and specific requirements. Please contact us with your event details for a personalized quote.',
  },
  {
    question: 'Do you provide drivers with the buses for wedding transportation?',
    answer: 'Yes, every bus booking includes a professional, experienced driver who ensures the safety, punctuality, and smooth operation of the wedding transport.',
  },
  {
    question: 'Can the buses be decorated for weddings?',
    answer: 'Yes, we can arrange for the buses to be decorated to match the theme of your wedding. Just let us know your preferences and we’ll make sure everything looks beautiful for the big day.',
  },
  {
    question: 'Why choose Amruta Travels for wedding bus bookings in Pune?',
    answer: 'Amruta Travels is known for reliable, professional service with well-maintained buses, skilled drivers, and a focus on customer satisfaction. We’ll make sure your wedding transportation is comfortable, timely, and stress-free.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Deshmukh',
    role: 'Wedding Planner, Pune',
    text: 'We hired a 35-seater bus from Amruta Travels for our client’s wedding. The bus was well-maintained, and the driver was very courteous. Our guests were comfortable and on time. Great service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Patel',
    role: 'Bride, Pune',
    text: 'We used Amruta Travels for our wedding transportation. The 45-seater bus was perfect for our guests. It was clean, on time, and the driver was very professional. Everything went smoothly!',
    rating: 5,
  },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
{
place: "/images/keyword/1.jpg",
text: "Wedding Bus Booking in Pune"
},
{
place: "/images/keyword/2.jpg",
text: "Wedding Guest Bus Booking"
},
{
place: "/images/keyword/3.jpg",
text: "25 Seater Wedding Bus Booking"
},
{
place: "/images/keyword/4.jpg",
text: "32 Seater Wedding Bus Booking"
},
{
place: "/images/keyword/5.jpg",
text: "35 Seater Wedding Bus Booking"
},
{
place: "/images/keyword/6.jpg",
text: "45 Seater Wedding Bus Booking"
},
{
place: "/images/keyword/7.jpg",
text: "50 Seater Wedding Bus Booking"
},
{
place: "/images/keyword/8.jpg",
text: "Destination Wedding Bus Booking"
},
{
place: "/images/keyword/9.jpg",
text: "Wedding Transportation Booking"
},
{
place: "/images/keyword/10.jpg",
text: "Bus Booking for Wedding in Pune"
},
{
place: "/images/keyword/11.jpg",
text: "Marriage Bus Booking"
},
{
place: "/images/keyword/12.jpg",
text: "Corporate Wedding Bus Booking"
},
{
place: "/images/keyword/13.jpg",
text: "Wedding Event Bus Booking"
},
{
place: "/images/keyword/14.jpg",
text: "Wedding Group Bus Booking"
},
{
place: "/images/keyword/15.jpg",
text: "Outstation Wedding Bus Booking"
},
{
place: "/images/keyword/16.jpg",
text: "AC Wedding Bus Booking"
},
{
place: "/images/keyword/17.jpg",
text: "Wedding Bus Reservation Pune"
},
{
place: "/images/keyword/18.jpg",
text: "Family Wedding Bus Booking"
},
{
place: "/images/keyword/19.jpg",
text: "Non AC Wedding Bus Booking"
},
{
place: "/images/keyword/20.jpg",
text: "Luxury Wedding Bus Booking"
},
{
place: "/images/keyword/22.jpg",
text: "Luxury Wedding Travel Booking"
},
{
place: "/images/keyword/23.jpg",
text: "Destination Marriage Bus Booking"
},
{
place: "/images/keyword/24.jpg",
text: "Wedding Bus Booking for Guests"
},
{
place: "/images/keyword/25.jpg",
text: "Wedding Reception Bus Booking"
},
{
place: "/images/keyword/26.jpg",
text: "Wedding Group Transportation"
}
];


    const images = [
{
src: "/images/gallery/24.jpg",
alt: "Bus Booking for Wedding in Pune"
},
{
src: "/images/gallery/28.jpg",
alt: "Wedding Guest Transportation Bus"
},
{
src: "/images/gallery/2.jpg",
alt: "Wedding Bus Booking Service"
},
{
src: "/images/gallery/3.jpg",
alt: "Luxury Wedding Bus in Pune"
},
{
src: "/images/gallery/24.jpg",
alt: "Marriage Bus Booking"
},
{
src: "/images/gallery/27.jpg",
alt: "Wedding Group Bus Booking"
},
{
src: "/images/gallery/29.jpg",
alt: "Destination Wedding Bus Booking"
},
{
src: "/images/gallery/30.jpg",
alt: "Wedding Transportation Service Pune"
},
{
src: "/images/gallery/31.jpg",
alt: "AC Wedding Bus Booking Pune"
}
];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Booking for Wedding in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-booking-for-wedding.jpg",
  "description": "Book a bus for your wedding in Pune with Amruta Travels. Choose from AC or Non-AC buses for your wedding transport needs. Comfortable party buses, shuttle rentals, and outstation buses available for weddings, marriage events, and receptions.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5237"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "45", // Adjust based on per km or flat rate for wedding bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-booking-for-wedding-in-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus Booking for Wedding in Pune | Wedding Bus Rental & Party Transport | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book a bus for your wedding in Pune with Amruta Travels. Rent AC or Non-AC buses for wedding transport, party buses, and outstation wedding bookings. Affordable and comfortable travel options for your special day." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busbookingforweddindtripinpune;